import React, { useCallback } from 'react';
import { useReactiveVar } from '@apollo/client';
import { nationalTaxServiceCredentialsDialogVar } from '../../apollo/reactive-variables/alerts';
import NationalTaxServiceCredentialsDialogContent from './NationalTaxServiceCredentialDialogContent';

const NationalTaxServiceCredentialsDialog = () => {
  const { open, autocomplete, showTerms, source } = useReactiveVar(
    nationalTaxServiceCredentialsDialogVar,
  );

  const handleClose = useCallback(
    () => nationalTaxServiceCredentialsDialogVar({
      open: false,
      autocomplete: false,
      showTerms: true,
      source: null,
    }),
    [nationalTaxServiceCredentialsDialogVar],
  );

  if (!open) {
    return null;
  }

  return (
    <NationalTaxServiceCredentialsDialogContent
      open={open}
      onClose={handleClose}
      autocomplete={autocomplete}
      showTerms={showTerms}
      source={source}
    />
  );
};

export default NationalTaxServiceCredentialsDialog;
